/*!
 * Bootstrap Context Menu
 * Version: 2.1
 * A small variation of the dropdown plugin by @sydcanem
 * https://github.com/sydcanem/bootstrap-contextmenu
 *
 * New options added by @jeremyhubble for javascript launching
 *  $('#elem').contextmenu({target:'#menu',before:function(e) { return true; } });
 *
 *
 * Twitter Bootstrap (http://twitter.github.com/bootstrap).
 */

/* =========================================================
 * bootstrap-contextmenu.js
 * =========================================================
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================= */

!(function ($) {
    'use strict'; // jshint ;_;

    /* CONTEXTMENU CLASS DEFINITION
	 * ============================ */

    var ContextMenu = function (elements, options) {
        this.$elements = $(elements);
        this.options = options;
        this.before = this.options.before || this.before;
        this.onItem = this.options.onItem || this.onItem;
        if (this.options.target)
            this.$elements.attr('data-target', this.options.target);

        this.listen();
    };

    ContextMenu.prototype = {
        constructor: ContextMenu,
        show: function (e) {
            var self = this;
            this._clickEvent = e;

            var $this = $(this);

            if ($this.is('.disabled, :disabled'))
                return;

            var evt = $.Event('context');
            if (!this.before.call(this, e, $(e.currentTarget)))
                return;

            this.$elements.trigger(evt);
            var $menu = this.getMenu();
            var tp = this.getPosition(e, $menu);

            $menu.attr('style', '').css(tp).addClass('open');

            $('html')
                .on('click.context.data-api', $.proxy(this.closemenu, this));
            $menu
                .off('click.context')
                .on('click.context.data-api', function (e) {
                    self.onItem.call(this, e, $(e.target));
                });

            return false;
        },
        reposition: function () {
            var $menu = this.getMenu();
            var tp = this.getPosition(null, $menu);
            $menu.css(tp);
        },
        closemenu: function (e) {
            this.getMenu().removeClass('open');
            $('html').off('click.context');
        },
        before: function (e) {
            return true;
        },
        onItem: function (e, context) {
            return true;
        },
        listen: function () {
            this.$elements
                .on('contextmenu.context.data-api', $.proxy(this.show, this));

            var $target = $(this.$elements.attr('data-target'));
        },
        getMenu: function () {
            var selector = this.$elements.attr('data-target');

            if (!selector) {
                selector = this.$elements.attr('href');
                selector = selector && selector.replace(/.*(?=#[^\s]*$)/, ''); //strip for ie7
            }

            return $(selector);
        },
        getPosition: function (e, $menu) {
            e = e || this._clickEvent;
            var mouseX = e.clientX,
                mouseY = e.clientY,
                boundsX = $(window).width(),
                boundsY = $(window).height(),
                menuWidth = $menu.find('.dropdown-menu').outerWidth(),
                menuHeight = $menu.find('.dropdown-menu').outerHeight(),
                tp = { 'position': 'fixed' },
                Y = {
                    'top': mouseY + menuHeight > boundsY
                        ? mouseY - menuHeight
                        : mouseY
                },
                X = {
                    'left': (mouseX + menuWidth > boundsX) && ((mouseX - menuWidth) > 0)
                        ? mouseX - menuWidth
                        : mouseX
                };

            return $.extend(tp, Y, X);
        },
        clearMenus: function (e) {
            if (!e.ctrlKey) {
                $('[data-toggle=context]').each(function () {
                    this.getMenu().removeClass('open');
                });
            }
        }
    };

    /* CONTEXT MENU PLUGIN DEFINITION
	 * ========================== */

    $.fn.contextmenu = function (option, e) {
        var $this = this;
        return (function () {
            var data = $this.data('context'), options = typeof option == 'object' && option;

            if (!data) $this.data('context', (data = new ContextMenu($this, options)));
            // "show" method must also be passed the event for positioning
            if (typeof option == 'string') data[option].call(data, e);
        })();
    };

    $.fn.contextmenu.Constructor = ContextMenu;

    /* APPLY TO STANDARD CONTEXT MENU ELEMENTS
	 * =================================== */

    $(document)
        .on('contextmenu.context.data-api', '[data-toggle=context]', function (e) {
            $(this).contextmenu('show', e);
            e.preventDefault();
        });
}(window.jQuery));
